module.exports = __webpack_public_path__ + "img/photo-lpc.6d65fe4e.jpg";